<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <vx-card>
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-1/3 mt-5">
          <h6 class="mb-2">Nome da Marca</h6>
          <vs-input name="name"  v-validate="'required'" v-model="name" class="w-full" />
          <br />
            <span class="text-danger">{{ errors.first("name") }}</span>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-full mt-5">
          <vs-button
            type="filled"
            icon-pack="feather"
            icon="icon-save"
            @click="submit"
            class="
              p-3
              mb-4
              mr-4
              rounded-lg
              cursor-pointer
              flex
              items-center
              justify-between
              bg-success
            "
            >Salvar</vs-button
          >
    
      </div>
      </div>
    </vx-card>
    <br />
  </div>
</template>


<script>
import { Validator } from "vee-validate";
import axios from "axios";
import { baseApiUrl } from "@/global";
import router from "@/router";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import { momentJS } from "@/helpers";
import { VueGoodTable } from "vue-good-table";
const dict = {
  custom: {
     name: {
      required: "Digite o nome da Marca",
    },
  },
};

Validator.localize("en", dict);
export default {
  components: {
    "v-select": vSelect,
    Datepicker,
    VueGoodTable,
  },
  data() {
    return {
      date: null,
      languages: lang,
      name: null,
    };
  },
  computed: {
    },
  methods: {
    async submit() {
      const haveErrors = !(await this.$validator.validateAll());
      console.log(haveErrors)
     if (haveErrors) return;
  
      let data = {
        name: this.name,
        createAt: momentJS().getDateTime(),
        modifiedAt: momentJS().getDateTime(),
        createBy: this.$store.state.user.idUser,
        modifiedBy: this.$store.state.user.idUser,
      };
      try {
        this.$vs.loading();
        await axios.post(`${baseApiUrl}/trademark/save`, data);
        this.$vs.notify({
          title: "Salvo",
          text: "com Sucesso",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });
        router.push("/marcas").catch(() => {});
      } catch (error) {
        if (!error.response || !error.response.data) return;
        this.$vs.notify({
          title: "Ocorreu algum problema",
          text: error.response.data,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  created() {
   
  },
};
</script>
 
